// extracted by mini-css-extract-plugin
export var autoExpand = "_20-8";
export var container = "_20-7";
export var containerWidth = "_20-5";
export var disabled = "_20-2";
export var error = "_20-3";
export var fullWidth = "_20-6";
export var inputWrapper = "_20-0";
export var small = "_20-1";
export var textarea = "_20-4";